"use strict";
const cheerio = require('cheerio');
const pick = require('lodash/pick');
const isEmpty = require('lodash/isEmpty');
const { v4: uuidv4 } = require('uuid');
const cryptoService = require('../services/cryptoServiceDeprecated');
const shortenPageInfo = ($, linkFieldElement) => {
    const destinationPageInfoFields = $(linkFieldElement).find('destination-page-info-field');
    const accountAttributes = [];
    const userAttributes = [];
    const userActivities = [];
    destinationPageInfoFields.each((index, linkUrlFieldElement) => {
        const attribute = linkUrlFieldElement.attribs;
        switch (attribute.attribute_type) {
            case 'userAttributes':
                userAttributes.push(pick(attribute, ['key', 'value', 'type']));
                break;
            case 'accountAttributes': {
                accountAttributes.push(pick(attribute, ['key', 'value', 'type']));
                break;
            }
            case 'userActivities': {
                const userActivitiesProps = {
                    module: attribute.module,
                    moduleActions: attribute.actions.split('$$$'),
                };
                userActivities.push(userActivitiesProps);
                break;
            }
            default:
                break;
        }
    });
    return {
        ...!isEmpty(accountAttributes) && { aa: accountAttributes },
        ...!isEmpty(userAttributes) && { ua: userAttributes },
        ...!isEmpty(userActivities) && { ac: userActivities },
    };
};
const buildDestinationPageLink = ($, linkFieldElement, args, encryptionPassword, destinationPageUrl) => {
    const { campaignId, serviceId, accountId, userId } = args;
    const { destination_page_update_type: destinationPageUpdateType, destination_page: destinationPage, destination_page_name: destinationPageValue } = linkFieldElement.attribs;
    const params = {
        c: campaignId,
        s: serviceId,
        a: accountId,
        u: userId,
        uuid: uuidv4(),
        ut: destinationPageUpdateType,
        ui: shortenPageInfo($, linkFieldElement),
        v: destinationPageValue,
        d: new Date().getTime(), // we add the date to ensure that each link is unique
    };
    const key = cryptoService.encrypt(JSON.stringify(params), encryptionPassword);
    return `${destinationPageUrl}/${destinationPage}/${key}`;
};
const getLinkUrl = ($, linkFieldElement, args, encryptionPassword, destinationPageUrl) => {
    const { fallback } = linkFieldElement.attribs;
    const destinationPage = linkFieldElement.attribs.destination_page;
    const linkUrlFieldsElements = $(linkFieldElement).find('.link-url span');
    if (destinationPage) {
        return buildDestinationPageLink($, linkFieldElement, args, encryptionPassword, destinationPageUrl);
    }
    let useFallback = false;
    linkUrlFieldsElements.each((index, linkUrlFieldElement) => {
        if (!$(linkUrlFieldElement).text()) {
            useFallback = true;
        }
    });
    return useFallback ? fallback : $(linkFieldElement).find('.link-url').text();
};
const parseLinkField = (html, args, encryptionPassword, destinationPageUrl) => {
    const $ = cheerio.load(html, null, false);
    const linkFieldElements = $('link-field');
    linkFieldElements.each((index, linkFieldElement) => {
        const disableTracking = linkFieldElement.attribs.disable_tracking === 'true';
        // TODO need add logic for: uniqueName
        const linkUrl = getLinkUrl($, linkFieldElement, args, encryptionPassword, destinationPageUrl);
        const clickTracking = disableTracking ? 'off' : 'on';
        const linkContentSpan = $(linkFieldElement).find('.link-content span');
        $(linkFieldElement).replaceWith(`<a target="_blank" href="${linkUrl}" clicktracking="${clickTracking}">${linkContentSpan}</a>`);
    });
    return $.html();
};
module.exports = {
    parseLinkField,
};
//# sourceMappingURL=destinationPage.js.map